var map = {
	"./Heroes Legend.ttf": 855,
	"./ProximaNova-Black.otf": 856,
	"./ProximaNova-Bold.otf": 857,
	"./ProximaNova-Extrabold.otf": 858,
	"./ProximaNova-Light.otf": 859,
	"./ProximaNova-Regular.otf": 860,
	"./ProximaNova-Semibold.otf": 861,
	"./heroes_legend-webfont.woff": 862,
	"./heroes_legend-webfont.woff2": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 854;